import Instance from '../../../Axios';

// New Actions for the app

const GetCategoria = (id) => async (dispatch) => {
  console.log('id', id);
  await Instance()
    .get(`/backend/categorias/${id}`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_CATEGORIA', payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCategoria;
